import React from 'react';
import $ from 'jquery';
import SupplierService from '../services/supplier';
import NumberFormat from 'react-number-format';
import Modal from 'react-bootstrap/Modal';
import CountryService from '../services/country';
import AuthorizationCheck from '../auth/authorizationCheck';
import Utility from '../utilities/utility';
import BranchService from '../services/branch';
import Customer from '../services/customer';
import ShippingService from '../services/shipping';

class BranchAdmin extends React.Component {

    constructor(props) {
        super(props);
        this.countryService = new CountryService();
        this.branchService = new BranchService();
        this.shippingService = new ShippingService();

        this.customerService = new Customer();

        this.state = {

            countries: [],
            currentUserRole: '',
            showModal: false,
            showCreateBranchModal: false,
            branches: [],
            timeoutId: null,
            customers: [],
            countryShipments: []
        };
    }

    componentDidMount() {


        this.fetchCountries();

    }

    searchBranch = () => {

        let timer;

        clearTimeout(this.state.timeoutId);

        timer = setTimeout(() => {
            this.branchList();
        }, 1500);

        this.setState({ timeoutId: timer })
    }













    handleCloseModal = () => {

        this.setState({ showModal: false })
    }

    handleCloseCreateBranchModal = () => {

        this.setState({ showCreateBranchModal: false })
    }

    showCreateBranchModal = () => {

        this.setState({ showCreateBranchModal: true })
    }


    fetchCountries = async () => {

        try {

            const response = await this.countryService.fetchCountries();

            this.setState({
                countries: await response.json()
            });

        } catch (error) {
            console.log(error)
        }

    }



    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    customerList = async () => {



        try {

            let searchTerm = '';

            let countryId = $('#selectedCountryId').val();

            if (Utility.isEmpty(countryId)) {

                Utility.showAlertWithId('errorHolder', 'Veillez choisir le pays', 'danger', true);

                return;
            }

            const res = await this.customerService.customerList(countryId, searchTerm);

            if (res.ok) {

                this.setState({
                    customers: await res.json()
                });
            }



        } catch (error) {

            console.log(error);

        }


    }

    branchList = async () => {

        try {

            let countryId = $('#selectedCountryId').val();

            if (Utility.isEmpty(countryId)) {

                Utility.showAlertWithId('errorHolder', 'Veillez choisir le pays', 'danger', true);

                return;
            }
            let name = $('#searchName').val();

            const response = await this.branchService.branchList(countryId, name);

            this.setState({

                branches: await response.json()
            });
        } catch (error) {

            console.log(error);
        }


    }

    setBranch = async (branchId, e) => {

        e.preventDefault();

        try {

            let countryId = $('#selectedCountryId').val();

            if (Utility.isEmpty(countryId) || Utility.isEmpty(branchId)) {

                Utility.showAlertWithId('errorHolder', 'Required params missing', 'danger', true);

                return;
            }


            const response = await this.branchService.setUserBranch(countryId, branchId);

            if (response.ok) {

                Utility.showAlertWithId('errorHolder', 'Users updated', 'success', true);
            } else {

                Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
            }
        } catch (error) {

            console.log(error);

            Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
        }


    }

    loadData = () => {

        this.branchList();

        this.customerList();
        this.countryShipmentList();
    }

    setBranchOrdersFromCustomerOrders = async (customerId, e) => {

        e.preventDefault();

        try {


            let branchId = $('#branchId').val();

            console.log(branchId);



            if (Utility.isEmpty(branchId)) {

                Utility.showAlertWithId('errorHolder', 'Required params missing', 'danger', true);

                return;
            }


            const response = await this.branchService.setBranchOrderFromCustomerOrders(branchId, customerId);

            if (response.ok) {

                Utility.showAlertWithId('errorHolder', 'Users updated', 'success', true);
            } else {

                Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
            }
        } catch (error) {

            console.log(error);

            Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
        }


    }


    setCountryShipmentsBranch = async (branchId, e) => {

        e.preventDefault();

        try {

            let countryId = $('#selectedCountryId').val();

            if (Utility.isEmpty(countryId) || Utility.isEmpty(branchId)) {

                Utility.showAlertWithId('errorHolder', 'Required params missing', 'danger', true);

                return;
            }


            const response = await this.shippingService.setCountryShipmentBranch(countryId, branchId);

            if (response.ok) {

                Utility.showAlertWithId('errorHolder', 'Users updated', 'success', true);
            } else {

                Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
            }
        } catch (error) {

            console.log(error);

            Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
        }


    }


    countryShipmentList = async () => {



        try {

            let countryId = $('#selectedCountryId').val();

            if (Utility.isEmpty(countryId)) {

                Utility.showAlertWithId('errorHolder', 'Required params missing', 'danger', true);

                return;
            }


            const response = await this.shippingService.countryShipmentList(countryId);

            this.setState({

                countryShipments: await response.json()
            })
        } catch (error) {

            console.log(error);

            Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
        }


    }


    setShipmentBranch = async (shipmentId, e) => {

        e.preventDefault();

        try {


            let branchId = $('#branchId').val();



            if (Utility.isEmpty(branchId)) {

                Utility.showAlertWithId('errorHolder', 'Required params missing', 'danger', true);

                return;
            }


            const response = await this.shippingService.setShipmentBranch(shipmentId, branchId);

            if (response.ok) {

                Utility.showAlertWithId('errorHolder', 'Users updated', 'success', true);
            } else {

                Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
            }
        } catch (error) {

            console.log(error);

            Utility.showAlertWithId('errorHolder', 'Issue during operation', 'danger', true);
        }


    }



    render() {



        const branches = this.state.branches;
        let customers = this.state.customers;
        let countryShipments = this.state.countryShipments;

        const rightBtn = {
            width: 200,
            marginLeft: '80%'
        }

        return (


            <div className="container">



                <AuthorizationCheck accessLevel='SUPER_ADMIN' userRole={this.setRole} />


                <h2>Branches</h2>

                <div className='form-wrapper'>

                    <div className="form-group">
                        <label className="label">Pays</label>
                        <select className="form-control full-width mt-2" id="selectedCountryId" onChange={this.loadData}>
                            <option></option>
                            {this.state.countries.length > 0 && this.state.countries.map(country =>



                                <option key={country.countryId} value={country.countryId}>{country.name}</option>

                            )}
                        </select>

                    </div>


                    <div className='form-group'>
                        <label className="label">Branches</label>
                        <select className='form-control' id='branchId'>
                            <option></option>

                            {branches.length > 0 && branches.map(branch =>

                                <option value={branch.branchId}> {branch.name} </option>

                            )}

                        </select>



                    </div>

                </div>





                <div className='row border border-2'>

                    <div className='col'>

                        <h2>Set Branch From Country Orders</h2>

                        <div id='errorHolder'></div>




                        <div className="branch-wrapper mt-4">

                            {branches.length > 0 && branches.map(branch =>

                                <div className="card card-default mt-2" key={branch.branchId}>

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col text-start">{branch.name}</div>

                                            <div className="col"><button className='btn btn-primary' onClick={(e) => this.setBranch(branch.branchId, e)}>SET USERS BRANCH</button></div>



                                        </div>
                                    </div>

                                </div>
                            )}

                        </div>






                    </div>

                    <div className='col'>
                        <h2>Set Customer Branch Orders</h2>

                        <div className='container'>






                            {customers.length > 0 && customers.map(customer =>

                                <div className="card card-default mt-2" key={customer.customerId}>

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col">{customer.name}</div>

                                            <div className="col">{customer.address}</div>


                                            <div className="col">
                                                <button className='btn btn-primary full-width' onClick={(e) => this.setBranchOrdersFromCustomerOrders(customer.customerId, e)}>Set Customer Orders</button>
                                            </div>



                                        </div>
                                    </div>

                                </div>


                            )}

                        </div>
                    </div>

                </div>


                <div className='row border border-2 mt-3'>

                    <div className='col'>
                        <h2>Set Country Shipments Branch</h2>


                        <div className='form-group'>

                            <label className='label'>Branches</label>



                            {branches.length > 0 && branches.map(branch =>


                                <div className="card card-default mt-2" key={branch.branchId}>

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col text-start">{branch.name}</div>

                                            <div className="col"><button className='btn btn-primary' onClick={(e) => this.setCountryShipmentsBranch(branch.branchId, e)}>SET Country Shipments BRANCH</button></div>



                                        </div>
                                    </div>

                                </div>



                            )}





                        </div>

                    </div>

                    <div className='col'>
                        <h2>Set Shipment Branch</h2>

                        {countryShipments != null && countryShipments.map(shipment =>

                            <div className="card card-default mt-2" key={shipment.shipmentId}>

                                <div className="card-body">
                                    <div className="row">
                                        <div className="col text-start">{shipment.description}</div>

                                        <div className="col"><button className='btn btn-primary' onClick={(e) => this.setShipmentBranch(shipment.shipmentId, e)}>SET Shipment BRANCH</button></div>



                                    </div>
                                </div>

                            </div>
                        )}
                    </div>
                </div>








            </div>



        );


    }

}

export default BranchAdmin;